import type { RouteQueryLike } from './types';

export function parsePreviewQuery(query: RouteQueryLike): {
  contentType: string | null;
  token: string | null;
} {
  return {
    contentType: typeof query.content_type === 'string' ? query.content_type : null,
    token: typeof query.token === 'string' ? query.token : null,
  };
}
